import React from 'react';
import { AddInternalProcurementType } from 'models/procurement.model';
import AddProcurementForm from '../new-procurement/add-procurement-form';

const KitchenUpdateRejectedProcurementDetails = ({
  formData,
  setValue,
  removeItem,
  addForm,
  canWrite
}: {
  formData: AddInternalProcurementType[];
  setValue: (
    index: number,
    field: keyof AddInternalProcurementType,
    value: AddInternalProcurementType[keyof AddInternalProcurementType]
  ) => void;
  removeItem: (index: number) => void;
  addForm: () => void;
  canWrite: boolean;
}) => {
  return (
    <div>
      {formData.map((data, index) => (
        <AddProcurementForm
          key={index}
          data={data}
          index={index}
          setValue={setValue}
          removeItem={removeItem}
          canWrite={canWrite}
        />
      ))}
      {canWrite && (
        <button onClick={addForm} className='text-[#0080E5] mt-2 font-medium text-sm'>
          + Add Item
        </button>
      )}
    </div>
  );
};

export default KitchenUpdateRejectedProcurementDetails;
